<template>
  <div class="login-form">
    <header>
      <el-row
        type="flex"
        justify="center">
        <el-col :span="12">
          <div class="logo">
            <img
              src="~@/assets/agco-logo.svg"
              alt="AGCO">
          </div>
        </el-col>
      </el-row>
    </header>
    <el-row
      type="flex"
      justify="center">
      <el-col :span="18">
        <p>Introduzca su usuario y contraseña para iniciar sesión.</p>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      justify="center">
      <el-col :span="18">
        <el-form
          ref="form"
          :model="model"
          :rules="rules"
          label-position="top"
          @submit.native.prevent="onSubmit"
        >
          <main>
            <el-form-item
              prop="username"
              label="Usuario"
              label-width="20px"
            >
              <el-input
                v-model="model.username"
                placeholder="Usuario"
                prefix-icon="icon-user"
                class="login-input"
              />
            </el-form-item>
            <el-form-item
              prop="password"
              label="Contraseña"
            >
              <el-input
                v-model="model.password"
                placeholder="Contraseña"
                type="password"
                prefix-icon="icon-lock"
              />
            </el-form-item>
            <el-checkbox v-model="model.rememberMe">Recordar mi sesión</el-checkbox>
          </main>
          <footer>
            <el-row>
              <el-col :span="24">
                <el-button
                  v-loading.fullscreen.lock="loading"
                  native-type="submit"
                  type="primary"
                >Iniciar Sesión
                </el-button>
              </el-col>
            </el-row>
          </footer>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import Login from '@/models/login/login.model'
import AuthService from '@/services/auth.service'
export default {
  name: 'LoginForm',
  data () {
    return {
      model: Login.model(),
      rules: Login.rules,
      loading: false
    }
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          AuthService.authenticate(this.model.username, this.model.password, this.model.rememberMe)
            .then((response) => {
              this.loading = false

              this.$router.push(AuthService.redirectURL)
              AuthService.redirectURL = null
            })
            .catch(e => {
              this.loading = false

              switch (e.response.status) {
                case 401:
                case 422:
                  this.$notify.error({message: 'Usuario y/o contraseña incorrecto', title: 'Revisar los campos'})
                  break
                case 429:
                  this.$notify.warning({message: 'Demasiados intentos de ingreso', title: 'Espere unos minutos'})
                  break
              }
              this.hasError = true
              this.$emit('onError', this.hasError)
            })
        }
      })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.login-form{
  z-index: 101;
  background-color: #ffffff;
  border-radius: 3px;
  height: 500px;
  header{
    padding: 25px;
    border-bottom: 1px solid $border-primary;
    .logo{
      img{
        height: 50px;
        width: 140px;
      }
    }
  }
  footer{
    margin-top: 20px;
    .el-button{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/login/login-form.vue